<template>
    <v-card flat>
        <v-card-text>
            <v-card-title primary-title>
                <div>
                    <h3 class="headline mb-0">Información Familiar</h3>
                </div>
            </v-card-title>
            <v-form v-model="valid" v-if="!cargandoDatosFamiliares">
                <v-container fluid grid-list-md>
                    <v-subheader class="pl-0">Datos del Padre</v-subheader>
                    <v-layout row wrap>
                        <v-flex xs12 md8>
                            <v-text-field
                                    v-model="datosFamiliares.padre.nombre"
                                    :rules="rules.nombrePadre"
                                    label="Nombre"
                                    required
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                    v-model="datosFamiliares.padre.telefono"
                                    label="Teléfono"
                                    :mask="'phone'"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field
                                    v-model="datosFamiliares.padre.domicilio"
                                    label="Domicilio (Calle y Número)"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field
                                    v-model="datosFamiliares.padre.colonia"
                                    label="Colonia"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-text-field
                                    v-model="datosFamiliares.padre.ciudad"
                                    label="Ciudad"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-autocomplete
                                    :items="estados"
                                    v-model="datosFamiliares.padre.estado"
                                    item-value="id"
                                    item-text="nombre"
                                    label="Estado"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <v-subheader class="pl-0">Datos de la Madre</v-subheader>
                    <v-layout row wrap>
                        <v-flex xs12 md8>
                            <v-text-field
                                    v-model="datosFamiliares.madre.nombre"
                                    :rules="rules.nombreMadre"
                                    label="Nombre"
                                    required
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                    v-model="datosFamiliares.madre.telefono"
                                    label="Teléfono"
                                    :mask="'phone'"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field
                                    v-model="datosFamiliares.madre.domicilio"
                                    label="Domicilio (Calle y Número)"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field
                                    v-model="datosFamiliares.madre.colonia"
                                    label="Colonia"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-text-field
                                    v-model="datosFamiliares.madre.ciudad"
                                    label="Ciudad"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-autocomplete
                                    :items="estados"
                                    v-model="datosFamiliares.madre.estado"
                                    item-value="id"
                                    item-text="nombre"
                                    label="Estado"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-progress-linear :indeterminate="true" v-else="cargandoDatosFamiliares"></v-progress-linear>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    flat
                    @click="guardarDatosFamiliares"
                    :loading="guardarLoading"
                    :disabled="guardarLoading || !valid"
            >Guardar</v-btn>
        </v-card-actions>
        <v-snackbar
                :color="'success'"
                :top="'top'"
                :right="true"
                v-model="snackbar"
        >
            {{ snackbarMensaje }}
            <v-btn flat @click.native="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'

  export default {
    name: 'DatosFamiliares',
    created () {
      this.getDatosFamiliares()
    },
    data: () => ({
      valid: false,
      cargandoDatosFamiliares: false,
      guardarLoading: false,
      datosFamiliares: {},
      rules: {
        nombrePadre: [
          v => !!v || 'El nombre es requerido'
        ],
        nombreMadre: [
          v => !!v || 'El nombre es requerido'
        ]
      },
      snackbar: false,
      snackbarMensaje: ''
    }),
    computed: {
      ...mapState({
        estados: state => state.catalogs.listaEstados
      })
    },
    methods: {
      getDatosFamiliares () {
        this.cargandoDatosFamiliares = true
        axios.get('alumno/datos-familiares')
          .then(resp => {
            this.cargandoDatosFamiliares = false
            this.datosFamiliares = resp.data.datosFamiliares
          })
          .catch(err => {
            console.log(err)
          })
      },
      guardarDatosFamiliares () {
        this.guardarLoading = true
        axios.put('alumno/datos-familiares', this.datosFamiliares)
          .then(resp => {
            this.guardarLoading = false
            this.snackbar = true
            this.snackbarMensaje = 'Se guardaron los datos correctamente'
            console.log(resp)
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/forms/DatosFamiliares.vue